export const GPU_DUTY_SAMPLE_PRESETS = [1_000, 5_000, 10_000, 50_000, 100_000] as const;
export const GPU_DUTY_MIN_SAMPLES = 1;
export const GPU_DUTY_MAX_SAMPLES = 100_000;
export const GPU_DUTY_CANCEL_FORCE_RESTART_MS = 3_000;
export const GPU_DUTY_DEFAULT_WANTED_MODE = "apply-wanteds" as const;

export const GPU_DUTY_DEFAULT_SAMPLES = 5_000;
